export default {
  title: 'New authorization',
  selectPreAuthorizationMessage: 'Select a type of pre-authorization to get started',
  successLabel: 'The authorization was created successfully.',
  errorLabel: 'An error occurred when creating the authorization.',
  buttons: {
    next: 'Continue',
    end: 'End',
    cancel: 'Cancel',
    return: 'Return',
    addFile: 'Attach',
    exit: 'Exit'
  },
  fields: {
    optional: 'Optional',
    currency: 'Currency',
    type: 'Select an authorization type to continue:',
    file: {
      empty: 'No attachments',
      preview: 'Preview'
    },
    claimType: {
      label: 'Request for',
      owner: 'Owner',
      beneficiary: 'Beneficiary'
    },
    formats: 'Files in {formats} formats up to {size}'
  },
  loadingMessage: 'Creando autorización...',
  diagnoses: {
    panelTitle: 'Diagnoses',
    title: 'Diagnoses',
    emptyDiagnoses: 'Diagnoses have not been added yet',
    customDiagnosisItemListLabel: 'Diagnosis',
    searchLabel: 'Search diagnosis',
    emptyList: 'No results found',
    addDiagnosisLabel: '+ Add "{value}"',
    maximumNumberOfItemsReached: 'The limit has been exceeded',
    errors: {
      repeated: 'You have already added this diagnosis'
    }
  },
}